import ky from "ky";
import { call, put, takeEvery } from "redux-saga/effects";
import { authorizedApi } from "tools/apiConfigurator";
import * as actions from "@p81-common/shell-core-js/dist/redux/signedUrlPost";

function* signedUrlPost(action) {
  try {
    let { name, icon } = action.payload;
    let { data } = yield authorizedApi
      .post("files/signed-url", {
        json: {
          filename: name,
        },
      })
      .json();

    let formData = new FormData();

    Object.entries(data.fields).forEach(([k, v]) => {
      formData.append(k, v);
    });
    formData.append("Content-Type", icon.type);
    formData.append("acl", "public-read");
    formData.append("file", icon);

    yield ky.post(data.url, { body: formData });

    yield put(actions.requestSuccess(data));

    if (action.resolve) {
      yield call(action.resolve, data.filename);
    }
  } catch (error) {
    yield put(actions.requestFailure(error));

    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.SIGNED_URL_POST_REQUEST, signedUrlPost);
}

export default saga;
